import { render, staticRenderFns } from "./TekModal.vue?vue&type=template&id=398ccdfa&scoped=true&"
import script from "./TekModal.vue?vue&type=script&lang=js&"
export * from "./TekModal.vue?vue&type=script&lang=js&"
import style0 from "./TekModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TekModal.vue?vue&type=style&index=1&id=398ccdfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ccdfa",
  null
  
)

export default component.exports